import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
import {
  fetchWithToken,
} from '@hublot-io/core-api/client'
import config from '../utils/apiUtils'
import dateUtils from '../utils/dateUtils'
import CommonUtils from '../utils/commonUtils'

export const AchatService = {
  getTypeAchats() {
    return [{
      idTypeAchats: 1,
      name: 'Facture',
    },
    {
      idTypeAchats: 2,
      name: 'Avoir',
    },
    {
      idTypeAchats: 3,
      name: 'Cession',
    },
    {
      idTypeAchats: 4,
      name: 'Cotisation',
    },
    {
      idTypeAchats: 5,
      name: 'Transport',
    },
    ]
  },
  getAchats(clientId, date = moment().format('YYYY-MM-DD')) {
    return fetchWithToken(`${config().achatService}?date=${date}`, {
      method: 'GET',
    }).then((response) => response.json())
  },
    getAchatsRange(clientId, dateStart, dateEnd) {
    return fetchWithToken(`${config().achatService}?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET',
    }).then((response) => response.json())
  },
  getFournisseurs(clientId) {
    return fetchWithToken(`${config().achatService}/fournisseurs/${clientId}`, {
      method: 'GET',
    }).then((response) => response.json())
  },
  insert(achat) {
    return fetchWithToken(`${config().syncService}/achats`, {
      method: 'PUT',
      body: JSON.stringify([{
        _id: achat._id || uuidv4(),
        ...achat,
        lastUpdate: moment().format('YYYY-MM-DD HH:mm:ss'),
        idFournisseur: achat.idFournisseur,
      }]),
    }).then(response => response.text())
  },
  delete(facture) {
    return fetchWithToken(`${config().achatService}`, {
      method: 'DELETE',
      body: JSON.stringify({
        ...facture,
      }),
    }).then((response) => response.json())
  },
  generateTableauAchats: (achatsData, date = moment().format('YYYY-MM-DD'), fournisseurs,
    factureTypes) => dateUtils.getMonthDays(date).map(day => ({
    date: day,
    factures: AchatService.filterFacture(achatsData.factures, day, fournisseurs,
      factureTypes),
    avoir: AchatService.sumAvoir(achatsData.factures, day, factureTypes),
    objectif: AchatService.getObjectif(achatsData.objectifJour, date, day),
    casse: AchatService.getCasse(achatsData.objectifJour, day),
  })),

  getCasse: (objectif = [], date) => {
    const achats = objectif.find(objectifJour => objectifJour.date === date)
    if (achats) {
      return achats.casse
    }
    return 0
  },
  getObjectif: (objectif = [], dateAchats, date) => {
    const achats = objectif.find(objectifJour => objectifJour.date === date)
    const now = moment().format('YYYY-MM-DD')
    if (!achats || moment(date, 'YYYY-MM-DD').isAfter(moment(dateAchats, 'YYYY-MM-DD'))) {
      return 0
    } if ((dateAchats === date && !moment(dateAchats, 'YYYY-MM-DD').isBefore(now, 'YYYY-MM-DD')) || date === now) {
      return achats.caPrev
    }
    return achats.ca
  },
  filterFacture: (factures = [], date, fournisseurs, factureTypes) => {
    const factureId = factureTypes.find(type => type.name === 'Facture').idTypeAchats
    const transportId = factureTypes.find(type => type.name === 'Transport').idTypeAchats
    const cotisationId = factureTypes.find(type => type.name === 'Cotisation').idTypeAchats
    const cessionId = factureTypes.find(type => type.name === 'Cession').idTypeAchats
    const parsedFactures = factures.map(facture => ({
      ...facture,
      idFournisseur: facture.idFournisseur,
      date: moment(facture.date).format('YYYY-MM-DD'),
    }))

    const filteredFacture = AchatService
      .filterByDate(parsedFactures, date)
      .filter(facture => facture.type === factureId || facture.type === cessionId || facture.type === transportId || facture.type === cotisationId)
    return fournisseurs
      .slice() // make shallow-copy of array from store
      .sort((factureFournisseur1, factureFournisseur2) => factureFournisseur1.idFournisseur
        - factureFournisseur2.idFournisseur)
      .map(fournisseur => ({
        idFournisseur: fournisseur.idFournisseur,
        payed: filteredFacture.filter(facture => facture.idFournisseur === fournisseur.idFournisseur).every((facture) => CommonUtils.toBoolean(facture.payed) === true),
        montant: filteredFacture
          .filter(facture => facture.idFournisseur === fournisseur.idFournisseur)
          .reduce((total, facture) => total + parseFloat(facture.montant), 0),
      }))
  },
  sumAvoir: (factures, date, factureTypes) => {
    const avoirId = factureTypes.find(type => type.name === 'Avoir').idTypeAchats
    const parsedFactures = factures.map(facture => ({
      ...facture,
      idFournisseur: facture.idFournisseur,
      date: moment(facture.date).format('YYYY-MM-DD'),
    }))

    const sum = AchatService
      .filterByDate(parsedFactures, date)
      .filter(facture => facture.type === avoirId)
      .reduce((total, facture) => total + parseFloat(facture.montant), 0)

    return sum
  },
  filterByDate: (factures = [], date) => factures
    .filter(facture => facture.date === date),
}
